<h1>401</h1>
<h2>Acceso Denegado</h2>
<p class="bottom-spacing">No tienes los permisos necesarios para acceder a esta sección.</p>
<div class="text-center">
  <button mat-raised-button routerLink="/">Volver al inicio</button>
</div>
